import React, { useCallback } from 'react'
import { Button, Grid, Typography, makeStyles } from '@material-ui/core'
import { useShowPrompt } from 'civic-champs-shared/core/modal/hooks'
import { createMarkup } from 'civic-champs-shared/core/utils/helpers'
import EditGroupApplicationInstructionsDialog from './EditGroupApplicationInstructionsDialog'

const useStyles = makeStyles(() => ({
  fieldRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'baseline',
    marginBottom: '16px',
  },
  label: {
    fontSize: '18px',
    fontWeight: 600,
    marginRight: '10px',
    minWidth: '220px',
  },
  preview: {
    fontSize: '16px',
    maxWidth: '600px',
  },
  emptyPreview: {
    fontSize: '16px',
    fontStyle: 'italic',
    color: '#74777F',
  },
  editButton: {
    color: '#5C8DE8',
    marginLeft: '10px',
  },
}))

export default function GroupApplicationInstructionsField(props) {
  const { label, fieldName, value, emptyPreviewText, onSubmit } = props
  const classes = useStyles()
  const showEditDialog = useShowPrompt(EditGroupApplicationInstructionsDialog)

  const handleEdit = useCallback(async () => {
    const result = await showEditDialog({
      title: label,
      initialValue: value || '',
    })

    if (result) {
      await onSubmit({ [fieldName]: result.content || null })
    }
  }, [fieldName, label, onSubmit, showEditDialog, value])

  return (
    <Grid container className={classes.fieldRow} alignItems="baseline">
      <Grid item>
        <Typography variant="body1" className={classes.label}>
          {label}:
        </Typography>
      </Grid>
      <Grid item container alignItems="baseline" wrap="nowrap">
        {value ? (
          <Typography
            variant="body1"
            component="div"
            className={classes.preview}
            dangerouslySetInnerHTML={createMarkup(value)}
          />
        ) : (
          <Typography variant="body1" className={classes.emptyPreview}>
            {emptyPreviewText}
          </Typography>
        )}
        <Button variant="text" className={classes.editButton} onClick={handleEdit}>
          EDIT
        </Button>
      </Grid>
    </Grid>
  )
}
